import { spawn } from 'redux-saga/effects';

import agreementSagas from './agreement/agreementSagas';
import paymentSagas from './payment/paymentSagas';

export default function* sagas() {
	yield spawn(agreementSagas);
	yield spawn(paymentSagas);
}
